import { STATIC_DISPLAY_MAP as i, MODIFIER_NORMALIZATION_MAP as n } from "./constants.js";
function e(t) {
  return Object.hasOwn(n, t);
}
function O(t) {
  return Object.hasOwn(i, t);
}
export {
  e as isPhysicalModifier,
  O as isStaticKey
};
